import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Modal,
    Box,
    Button,
    Card,
    Alert,
    CardContent,
    Dialog, DialogTitle, DialogContent, DialogActions, ialogActions, TextField, MenuItem, Select, InputLabel
} from "@mui/material";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import LoadingButton from '@mui/lab/LoadingButton';
import LinearProgress from '@mui/material/LinearProgress';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Autocomplete from '@mui/material/Autocomplete';


import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import { fetchManifest, resetGenerateManifestNotification, dopostTrackingNumberCloseManifest, doRequestManifestPickup } from './manifestsSlice';
import {
    getPickupSettings,
    postPickupSettings,
    resetPickupSettingsState,
  } from "../../../pages/Settings/PickupSettings/pickupSettingsSlice";
//Custom Components Import Starts
import Carrier from '../../General/Carrier'
import NorowsData from '../../General/NorowsData'
import Search from './Search'
import Notification from '../../../pages/General/Notification'
import ManifestDrawer from '../../../pages/General/ManifestDrawer'
import Printer from '../../../pages/General/Printer'
import UnclosedShipmentDrawer from '../../../pages/General/UnclosedShipmentDrawer'
import PendingShipmentsDrawer from '../../../pages/General/PendingShipmentsDrawer'
import { fetchSenderAddress } from '../../../pages/Settings/AddressSender/addressSenderSlice';

import CustomDate from '../../../pages/General/Date'

//Custom Components Import Ends
function PickupModal({ 
    open, 
    onClose, 
    addresses, 
    selectedAddress, 
    setSelectedAddress, 
    selectedDate, // New state from parent
    setSelectedDate, 
    selectedSlot, 
    setSelectedSlot,
    handlePickup,
    loading 
}) {
    
    // Helper to get next 5 working days (Mon-Fri)
    const getAvailableDates = () => {
        const dates = [];
        let current = new Date();
        
        // Let's get the next 7 calendar days and filter for Mon-Fri
        for (let i = 1; i <= 7; i++) {
            let nextDay = new Date();
            nextDay.setDate(current.getDate() + i);
            let dayOfWeek = nextDay.getDay();
            
            if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Skip Sat (6) and Sun (0)
                const label = i === 1 ? `Tomorrow (${nextDay.toLocaleDateString()})` : nextDay.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
                dates.push({ label, value: nextDay.toISOString().split('T')[0] });
            }
            if (dates.length >= 5) break; // Limit to 5 options
        }
        return dates;
    };

    const timeSlots = [
        "9am to 1pm",
        "1pm to 5pm"
    ];

    const availableDates = getAvailableDates();

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle>Schedule Pickup Request</DialogTitle>
            <DialogContent style={{ paddingTop: '10px' }}>
                {/* Address Selection */}
                <Autocomplete
                    options={addresses}
                    value={selectedAddress || null}
                    onChange={(e, newValue) => setSelectedAddress(newValue)}
                    // 1. This controls the text inside the input field after selection
                    getOptionLabel={(option) =>
                        option ? `${option.sender_name} - ${option.sender_address}, ${option.sender_city}, ${option.sender_state_code} ${option.sender_postal_code}` : ""
                    }
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                            <div style={{ width: '100%' }}>
                                <strong>{option.sender_name}</strong> {option.sender_company ? `(${option.sender_company})` : ""}
                                <div style={{ fontSize: '0.85em', color: '#555', marginTop: '2px' }}>
                                    {option.sender_address}, {option.sender_city}, {option.sender_state_code} {option.sender_postal_code}, {option.sender_country_code}
                                </div>
                            </div>
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField 
                            {...params} 
                            label="Pickup Address" 
                            variant="outlined" 
                            margin="dense"
                            helperText={selectedAddress ? "Selected address will be used for pickup" : "Search or select a sender address"} 
                        />
                    )}
                />

                {/* Date Selection */}
                <FormControl fullWidth style={{ marginTop: '20px' }}>
                    <InputLabel>Select Pickup Date</InputLabel>
                    <Select
                        value={selectedDate}
                        label="Select Pickup Date"
                        onChange={(e) => setSelectedDate(e.target.value)}
                    >
                        {availableDates.map((date) => (
                            <MenuItem key={date.value} value={date.value}>{date.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Time Selection */}
                <FormControl fullWidth style={{ marginTop: '20px' }}>
                    <InputLabel>Select Time Slot</InputLabel>
                    <Select
                        value={selectedSlot}
                        label="Select Time Slot"
                        onChange={(e) => setSelectedSlot(e.target.value)}
                    >
                        {timeSlots.map(slot => (
                            <MenuItem key={slot} value={slot}>{slot}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <LoadingButton
                    variant="contained"
                    color="primary"
                    loading={loading}
                    disabled={!selectedAddress || !selectedSlot || !selectedDate}
                    onClick={handlePickup}
                >
                    Confirm Pickup
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
// Shared enterprise style object for the uniform action utilities matrix
const manifestUtilityIconStyles = (isActive) => ({
    color: '#1976d2', // --- FIXED CORPORATE ACCENT BLUE MATRIX BRAND TOKEN ---
    padding: '8px',
    borderRadius: '10px',
    backgroundColor: isActive ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
    border: isActive ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid #E2E8F0',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: isActive ? 'rgba(25, 118, 210, 0.12)' : 'rgba(241, 245, 249, 0.8)',
        borderColor: isActive ? 'rgba(25, 118, 210, 0.3)' : '#CBD5E1',
        transform: 'translateY(-1px)'
    },
    '&:active': {
        transform: 'translateY(0)'
    }
});

// Re-architected modal overlay layout canvas style specs matching enterprise standards
const enterpriseModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 460 }, // Smooth layout adaptation to smaller device screens
    bgcolor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 4,
    outline: 'none',
    overflow: 'hidden'
};
const ManifestsPage = () => {

    const dispatch = useDispatch();
    const manifest = useSelector(state => state.manifests);
    const profile = useSelector(state => state.auth.profile);
    const pickupsettings = useSelector((state) => state.pickupsettings);
    const addresssender = useSelector(state => state.addresssender);
    const [meta, setMeta] = useState(manifest.meta);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [manifestId, setManifestId] = useState("");
    const [manifestUrl, setManifestUrl] = useState("");
    const [refreshIntervalId, setRefreshIntervalId] = useState("")
    const [manifestDrawerVisible, setManifestDrawerVisible] = useState(false);
    const [openAllManifestCloseConfirmModal, setOpenAllManifestCloseConfirmModal] = useState(false)
    const [unclosedShipmentsDrawerVisible, setUnclosedShipmentsDrawerVisible] = useState(false)
    const [pendingShipmentsDrawerVisible, setPendingShipmentsDrawerVisible] = useState(false)
    const [shipmentType, setShipmentType] = useState("");
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [selectedManifests, setSelectedManifests] = useState([]);
    const [openPickupModal, setOpenPickupModal] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const isPickupLoading = manifest.pickupLoading;
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };
    const manifestCallback = (manifest_number, url = "") => {
        setManifestId(manifest_number);
        setManifestUrl(url)
        setManifestDrawerVisible(true)
    }

    const manifestOnClose = (values) => {
        setManifestDrawerVisible(false);
    };

    const closeAllUnmanifestedShipments = (value) => {
        let pickup_preference=false;
        if(value=="nopickup"){
            var postData = {
                "close_all_unclosed_shipments": true,
                "ignore_errors": true,
                "request_medium":"UI",
                "subuser_id":profile.id
            }
        }else{
            if(value==true){
                pickup_preference=true
            }else if(value==false){
                pickup_preference=false
            }
            var postData = {
                "close_all_unclosed_shipments": true,
                "ignore_errors": true,
                "pickup_preference":pickup_preference,
                "request_medium":"UI",
                "subuser_id":profile.id
            }
        }
        dispatch(dopostTrackingNumberCloseManifest(profile.id,postData, profile.api_token, meta))
        setOpenAllManifestCloseConfirmModal(false);
    }

    const callUnclosedShipments = () => {
        setUnclosedShipmentsDrawerVisible(true);
    }

    const unclosedShipmentsOnClose = () => {
        setUnclosedShipmentsDrawerVisible(false);
    }

    const callPendingShipments = (manifest_number, shipment_type) => {
        setManifestId(manifest_number);
        setShipmentType(shipment_type);
        setPendingShipmentsDrawerVisible(true);
    }

    const pendingShipmentsOnClose = () => {
        setPendingShipmentsDrawerVisible(false);
    }

    const columns = [
        {
            field: 'manifest_number',
            headerName: 'Manifest Number',
            headerClassName: 'super-app-theme--header',
            sortable: false,
            flex:1,
            renderCell: (params) => {
                return <span style={{ color: 'rgb(24, 144, 255)', cursor: 'pointer' }} onClick={e => { manifestCallback(params.row.manifest_number, params.row && params.row.carrier_manifest_url && params.row.carrier_manifest_url) }}>{params.row.manifest_number}</span>

            }
        },
        {
            field: 'status',
            headerName: 'Status',
            headerClassName: 'super-app-theme--header',
            flex:1,
            renderCell: (params) => {
                if (params.row.status) {
                    return params.row.status
                } else {
                    return "-"
                }
            }
        },
       
        // {
        //     field: 'total_shipments',
        //     headerName: 'Manifested Shipments',
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     renderCell: (params) =>
        //     {
        //         if(params.row.total_shipments !== 0){
        //             return <div> <a href='#' onClick={() => { callPendingShipments(params.row.manifest_number, "total_shipments") }} >{params.row.total_shipments} </a></div>
        //         }else{
        //             return <div><span>{params.row.total_shipments}</span></div>
        //         }
        //     }
        // },
        // {
        //     field: 'received_shipments',
        //     headerName: 'Received Shipments',
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     renderCell: (params) =>
        //     {
        //         if(params.row.received_shipments !== 0){
        //             return <div> <a href='#' onClick={() => { callPendingShipments(params.row.manifest_number, "received_shipments") }} >{params.row.received_shipments} </a></div>
        //         }else{
        //             return <div><span>{params.row.received_shipments}</span></div>
        //         }
        //     }
        // },
        // {
        //     field: 'not_yet_received_shipments',
        //     headerName: 'Not Yet Received Shipments',
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     renderCell: (params) =>
        //     {
        //         if(params.row.not_yet_received_shipments !== 0){
        //             return <div> <a href='#' onClick={() => { callPendingShipments(params.row.manifest_number, "not_yet_received_shipments") }} >{params.row.not_yet_received_shipments} </a></div>
        //         }else{
        //             return <div><span>{params.row.not_yet_received_shipments}</span></div>
        //         }
        //     }
        // },
        {
            field: 'created_at',
            headerName: 'Closed Date',
            headerClassName: 'super-app-theme--header',
            flex:1,
            renderCell: (params) => {
                return <CustomDate date={params.row.created_at} />
            }
        },
        {
            field: 'action',
            headerName: 'Manifest Action',
            sortable: false,
            flex:1,
            renderCell: (params) => {
            const isDisabled = !params.row.manifest_url;
            const isPickupRequested = !!params.row.pickup_enabled;
            return (
                <div>
                <span style={{ marginRight: '10px' }}>
                    <Tooltip title="View" placement="left-start">
                    <span>
                        <IconButton
                        disabled={isDisabled}
                        onClick={() => window.open(params.row.manifest_url, '_blank')}
                        >
                        <RemoveRedEyeIcon style={{ color: "#1890ff", cursor: isDisabled ? 'not-allowed' : 'pointer' }} />
                        </IconButton>
                    </span>
                    </Tooltip>
                </span>

                <span style={{ marginRight: '10px' }}>
                    <Tooltip title="Print" placement="left-start">
                    <span>
                        <IconButton
                        disabled={isDisabled}
                        onClick={() => {
                            setPrintUrl(params.row.manifest_url);
                            setIsPrinted(false);
                        }}
                        >
                        <LocalPrintshopIcon style={{ color: "#1890ff", cursor: isDisabled ? 'not-allowed' : 'pointer' }} />
                        </IconButton>
                    </span>
                    </Tooltip>
                </span>
                {profile?.enable_pickup_manifest && (
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title={isPickupRequested ? "Pickup already requested" : "Pickup Request"}>
                            <span>
                                <IconButton
                                    disabled={isDisabled || params.row.status !== 'CLOSED' || isPickupRequested}
                                    onClick={() => handleSinglePickupOpen(params.row.manifest_number)}
                                >
                                    <LocalShippingIcon
                                        style={{
                                            color: (isDisabled || params.row.status !== 'CLOSED' || isPickupRequested) 
                                                    ? "#d9d9d9" 
                                                    : "#1890ff",
                                            cursor: (isDisabled || params.row.status !== 'CLOSED' || isPickupRequested)
                                                    ? "not-allowed"
                                                    : "pointer"
                                        }}
                                    />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </span>
                )}
                </div>
            );
            }

        }
    ];

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }

    // ==========================================
    // PART 1: SUB-COMPONENTS ARCHITECTURE (TOOLBAR & PAGINATION)
    // ==========================================

    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows" 
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontSize: '12.5px', 
                        fontWeight: 600, 
                        color: '#475569',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        letterSpacing: '0.1px'
                    }}
                >
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {manifest && manifest.data && manifest.data.length}
                    </strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {(manifest && manifest.meta && manifest.meta.total) ? manifest.meta.total : 0}
                    </strong>
                </Typography>
            </Box>
        );
    }

    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        Show
                    </Typography>
                    
                    <FormControl 
                        size="small" 
                        variant="outlined" 
                        sx={{
                            minWidth: 75,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.2s',
                                border: '1px solid #E2E8F0',
                                '& fieldset': { border: 'none' },
                                '&:hover': { borderColor: '#CBD5E1' },
                                '&.Mui-focused': {
                                    borderColor: '#1976d2',
                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                }
                            },
                            '& .MuiSelect-select': {
                                padding: '6px 10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1E293B',
                                textAlign: 'center'
                            }
                        }}
                    >
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                        border: '1px solid #E2E8F0',
                                        '& .MuiMenuItem-root': {
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            py: 0.8,
                                            color: '#334155',
                                            '&.Mui-selected': {
                                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                color: '#1976d2',
                                                fontWeight: 700
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        entries
                    </Typography>
                </Stack>
            </Box>
        );
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{ 
                    p: 2, 
                    bgcolor: '#F8FAFC', 
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    width: '100%',
                    boxSizing: 'border-box',
                    gap: 2
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {
        return (
            <Box
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2', // --- SEAMLESS CORPORATE THEME ALIGNMENT ---
                            color: '#FFFFFF',
                            '&:hover': {
                                backgroundColor: '#115293'
                            }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={manifest && manifest.meta && manifest.meta.current_page}
                    count={manifest && manifest.meta && manifest.meta.last_page}
                    onChange={onChangePagination}
                />
            </Box>
        );
    }

    useEffect(() => {
        setMeta({
            ...meta,
            ...{
                shippingchimp_manifest_number: "",
            }
        });
    }, [dispatch])

    useEffect(() => {
        dispatch(fetchSenderAddress());
        dispatch(fetchManifest(meta))
    }, [meta]);

    useEffect(() => {
        if ((manifest && manifest.un_closed_shipments_count != 0 && manifest.manifest_all_in_progress == true) || (manifest && manifest.manifest_all_in_progress == true)) {
            if (refreshIntervalId == "") {
                let intervalId = setInterval(() => {
                    dispatch(fetchManifest(meta))
                }, 15000);
                setRefreshIntervalId(intervalId)
            }
        } else {
            if (manifest && manifest.manifest_all_in_progress == false && refreshIntervalId != "") {
                clearInterval(refreshIntervalId)
            }
        }
    }, [manifest.un_closed_shipments_count, manifest.manifest_all_in_progress]);

    useEffect(() => {
        dispatch(getPickupSettings());
      }, []);

    
   useEffect(() => {
        if (addresssender?.data?.length > 0) {
            const defaultAddress =
            addresssender.data.find(a => a.default) || addresssender.data[0];
            setSelectedAddress(defaultAddress);
        }
    }, [addresssender]); // ✅ only runs when API data changes

    // Reset state when modal closes
    const handleClosePickupModal = () => {
        setSelectedManifests([])
        setOpenPickupModal(false);
        setSelectedSlot(""); // clear slot
        setSelectedDate(""); // Clear date
        if (addresssender?.data?.length > 0) {
            const defaultAddress =
            addresssender.data.find(a => a.default) || addresssender.data[0];
            setSelectedAddress(defaultAddress); // reset to default
        } else {
            setSelectedAddress(null);
        }
    };
 

// Modified Single Pickup Handler (Truck Icon)
const handleSinglePickupOpen = (manifestNumber) => {
    setSelectedManifests([manifestNumber]); // Put single ID in the array
    setOpenPickupModal(true);
};


// The actual API Dispatch logic
const handlePickup = () => {
    const payload = {
        manifest_numbers: selectedManifests, // This works for both single and bulk now
        pickup_details: {
            name: selectedAddress.sender_name,
            company: selectedAddress.sender_company,
            address: selectedAddress.sender_address,
            city: selectedAddress.sender_city,
            state: selectedAddress.sender_state_code,
            postal_code: selectedAddress.sender_postal_code,
            country: selectedAddress.sender_country_code,
            phone: selectedAddress.sender_phone
        },
        time_slot: selectedSlot,
        pickup_date: selectedDate 
    };

    dispatch(doRequestManifestPickup(payload, profile.api_token, profile.id, meta));
    setSelectedManifests([])
    handleClosePickupModal();
};


    return (
        <>
            { (manifest && manifest.notification && manifest.notification.show) &&
                <Notification
                    is_open={manifest.notification.show}
                    messageType={manifest.notification.messageType}
                    messages={manifest.notification.messageContent}
                    handleClose={() => dispatch(resetGenerateManifestNotification())}
                />}
            {(manifest && manifest.manifestClose.notification && manifest.manifestClose.notification.show) &&
                <Notification
                    is_open={manifest.manifestClose.notification.show}
                    messageType={manifest.manifestClose.notification.messageType}
                    messages={manifest.manifestClose.notification.messageContent}
                    handleClose={() => dispatch(resetGenerateManifestNotification())}
                />}
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Modal
                open={openAllManifestCloseConfirmModal}
                aria-labelledby="manifest-confirm-modal-title"
                aria-describedby="manifest-confirm-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseModalStyle}>
                    
                    {/* Header Dialog Accent Component Line */}
                    <Typography 
                        id="manifest-confirm-modal-title" 
                        variant="h6" 
                        component="h2" 
                        sx={{ fontWeight: 800, color: '#0F172A', mb: 1.5, textAlign: 'center' }}
                    >
                        Confirm Bulk Action
                    </Typography>

                    {/* Context Narrative Label Block Component Description Area */}
                    <Typography 
                        id="manifest-confirm-modal-description" 
                        variant="body2" 
                        sx={{ 
                            color: '#475569', 
                            fontWeight: 500, 
                            lineHeight: 1.6, 
                            mb: 4, 
                            textAlign: 'center' 
                        }}
                    >
                        This action will close manifest for <strong>ALL</strong> shipments. <br />Do you want to proceed?
                    </Typography>

                    {/* Conditional Branching Layout Node based on operational profile preferences */}
                    {(pickupsettings &&
                    pickupsettings.data &&
                    pickupsettings.data.pickup_settings &&
                    pickupsettings.data.pickup_settings.pickup_preference &&
                    pickupsettings.data.pickup_settings.pickup_preference.pickup == true) && 
                    (pickupsettings &&
                    pickupsettings.data &&
                    pickupsettings.data.pickup_settings &&
                    pickupsettings.data.pickup_settings.pickup_preference &&
                    pickupsettings.data.pickup_settings.pickup_preference.dropoff == true) ? (
                        
                        /* Option Scenario A: Multi-Choice Selection Array (Pickup vs Dropoff vs No-Action Close) */
                        <Box 
                            sx={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                gap: 1.5,
                                width: '100%',
                                mt: 1
                            }}
                        >
                            <Box sx={{ display: 'flex', gap: 1.5, width: '100%', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                                <Button 
                                    variant="contained"  
                                    fullWidth
                                    onClick={() => { closeAllUnmanifestedShipments(true) }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        boxShadow: 'none',
                                        backgroundColor: '#1976d2', // --- CORPORATE ACCENT BLUE THEME MATRIX ACCENT ---
                                        color: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                    }}
                                >
                                    Yes, Arrange Pickup
                                </Button>
                                <Button 
                                    variant="contained" 
                                    fullWidth
                                    onClick={() => { closeAllUnmanifestedShipments(false) }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        boxShadow: 'none',
                                        backgroundColor: '#1976d2',
                                        color: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                    }}
                                >
                                    Yes, I Will Drop Off
                                </Button>
                            </Box>
                            <Button 
                                variant="outlined" 
                                fullWidth
                                onClick={() => { setOpenAllManifestCloseConfirmModal(false) }}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    borderColor: '#E2E8F0',
                                    color: '#475569',
                                    '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                }}
                            >
                                No, Cancel
                            </Button>
                        </Box>
                    ) : (
                        
                        /* Option Scenario B: Standard Binary Confirmation Logic Matrix (Proceed vs Cancel) */
                        <Box 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                gap: 1.5,
                                width: '100%',
                                mt: 1
                            }}
                        >
                            <Button 
                                variant="outlined" 
                                onClick={() => { setOpenAllManifestCloseConfirmModal(false) }}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 4,
                                    borderColor: '#E2E8F0',
                                    color: '#475569',
                                    '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                }}
                            >
                                No, Cancel
                            </Button>
                            <Button 
                                variant="contained"  
                                onClick={() => { closeAllUnmanifestedShipments("nopickup") }}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 5,
                                    boxShadow: 'none',
                                    backgroundColor: '#1976d2',
                                    color: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                }}
                            >
                                Yes, Proceed
                            </Button>
                        </Box>
                    )}
                </Box>
            </Modal>
            <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
        
                {/* 1. Header Segment Container */}
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        pb: 2.5,
                        pt: 1,
                        boxSizing: 'border-box'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography 
                            variant="h5" 
                            component="h2" 
                            sx={{ 
                                fontWeight: 800, 
                                color: '#0F172A',
                                letterSpacing: '-0.5px',
                                margin: 0
                            }}
                        >
                            Open Manifests
                        </Typography>
                    </Box>
                </Box>

                {/* 2. Premium Analytics and Operations Metrics Control Area Card Surface */}
                <Card 
                    sx={{ 
                        width: '100%', 
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E2E8F0',
                        borderRadius: '16px',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden'
                    }}
                >
                    <CardContent sx={{ p: { xs: 2.5, sm: 3 }, '&:last-child': { pb: { xs: 2.5, sm: 3 } } }}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                
                                {/* Column A: Modern KPI Metric Interactive Counter */}
                                <Grid item xs={12} sm={4} md={3} lg={2.5}>
                                    <Box 
                                        sx={{ 
                                            display: 'inline-flex', 
                                            flexDirection: 'column', 
                                            gap: 0.5,
                                            width: '100%'
                                        }}
                                    >
                                        <Typography 
                                            variant="caption" 
                                            sx={{ 
                                                textTransform: 'uppercase', 
                                                letterSpacing: '0.5px', 
                                                fontWeight: 700, 
                                                color: '#64748B' 
                                            }}
                                        >
                                            Total Packages
                                        </Typography>
                                        
                                        <Box sx={{ display: 'flex', alignItems: 'center', height: '36px' }}>
                                            {(manifest && manifest.un_closed_shipments_count && manifest.un_closed_shipments_count !== 0) ? (
                                                <Typography
                                                    component="a"
                                                    href="#"
                                                    onClick={(e) => { e.preventDefault(); callUnclosedShipments(); }}
                                                    sx={{
                                                        fontSize: '22px',
                                                        fontWeight: 800,
                                                        color: '#1976d2', // --- CORPORATE ACCENT BLUE ACCENT AXIS ---
                                                        textDecoration: 'none',
                                                        borderBottom: '2px solid transparent',
                                                        transition: 'all 0.15s ease-in-out',
                                                        lineHeight: 1,
                                                        '&:hover': {
                                                            color: '#115293',
                                                            borderBottomColor: '#115293'
                                                        }
                                                    }}
                                                >
                                                    {manifest.un_closed_shipments_count}
                                                </Typography>
                                            ) : (
                                                <Typography 
                                                    sx={{ 
                                                        fontSize: '22px', 
                                                        fontWeight: 800, 
                                                        color: '#1E293B',
                                                        lineHeight: 1 
                                                    }}
                                                >
                                                    {manifest.un_closed_shipments_count}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>

                                {/* Column B: Primary Operations Submission Pipeline Processing Trigger */}
                                <Grid item xs={12} sm={4} md={3} lg={2.5}>
                                    <LoadingButton
                                        variant="contained"
                                        fullWidth
                                        loading={manifest && manifest.manifestClose && manifest.manifestClose.loading}
                                        disabled={
                                            (manifest && manifest.manifestClose && manifest.manifestClose.loading) ||
                                            manifest.manifest_all_in_progress ||
                                            manifest.un_closed_shipments_count == 0
                                        }
                                        onClick={() => setOpenAllManifestCloseConfirmModal(true)}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13.5px',
                                            height: '40px',
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                                boxShadow: 'none',
                                                transform: 'translateY(-1px)'
                                            },
                                            '&:active': {
                                                transform: 'translateY(0)'
                                            },
                                            '&.Mui-disabled': {
                                                backgroundColor: '#E2E8F0',
                                                color: '#94A3B8'
                                            },
                                            // Style adaptations when the button is in its asynchronous loading loop state
                                            '& .MuiLoadingButton-loadingIndicator': {
                                                color: '#1976d2'
                                            }
                                        }}
                                    >
                                        {(manifest.manifest_all_in_progress == true) ? "Closing in progress" : "Close All Manifest"}
                                    </LoadingButton>
                                </Grid>

                                {/* Column C: Functional Context Warning Operational Pipeline Timeline Alert Banner */}
                                <Grid item xs={12} sm={4} md={6} lg={7}>
                                    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        {(manifest.manifest_all_in_progress == true) && (
                                            <Alert 
                                                severity="warning"
                                                variant="standard"
                                                sx={{ 
                                                    width: '100%', 
                                                    borderRadius: '10px',
                                                    fontWeight: 500,
                                                    fontSize: '13px',
                                                    color: '#B45309',
                                                    backgroundColor: '#FEF3C7',
                                                    border: '1px solid #FDE68A',
                                                    py: 0.5,
                                                    '& .MuiAlert-icon': {
                                                        color: '#D97706',
                                                        fontSize: '20px'
                                                    }
                                                }}
                                            >
                                                Please wait, closing manifest for all the shipments. Page will auto refresh until the process is completed.
                                            </Alert>
                                        )}
                                    </Box>
                                </Grid>

                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
            <div className="scmaincard">
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        pb: 2.5,
                        pt: 1,
                        marginTop:'10px',
                        flexWrap: 'wrap',
                        gap: 2,
                        boxSizing: 'border-box'
                    }}
                >
                    {/* Left Side Content Segment Typography Wrapper */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography 
                            variant="h5" 
                            component="h1" 
                            sx={{ 
                                fontWeight: 800, 
                                color: '#0F172A',
                                letterSpacing: '-0.5px',
                                margin: 0
                            }}
                        >
                            Closed Manifests
                        </Typography>
                    </Box>

                    {/* Right Side Operational Actions Controls Wrapper Layout */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box 
                            className="features-list"
                            component="div"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                p: 0,
                                m: 0
                            }}
                        >
                            {/* 1. Interactive Search Panel Toggle Utility Trigger */}
                            <Tooltip title="Search" placement="top">
                                <IconButton 
                                    sx={manifestUtilityIconStyles(showSearch)} 
                                    onClick={() => onMenuClick("search", !showSearch)}
                                >
                                    <SearchIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </Tooltip>

                            {/* 2. High-Priority Contextual Manifest Bulk Operations Activation Call */}
                            {profile?.enable_pickup_manifest && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={selectedManifests.length === 0}
                                    onClick={() => {
                                        setOpenPickupModal(true)
                                    }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        px: 2.5,
                                        boxShadow: 'none',
                                        backgroundColor: '#1976d2',
                                        color: '#FFFFFF',
                                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                        '&:hover': {
                                            backgroundColor: '#115293',
                                            boxShadow: 'none',
                                            transform: 'translateY(-1px)'
                                        },
                                        '&:active': {
                                            transform: 'translateY(0)'
                                        },
                                        '&.Mui-disabled': {
                                            backgroundColor: '#E2E8F0',
                                            color: '#94A3B8'
                                        }
                                    }}
                                >
                                    Bulk Pickup Request
                                </Button>
                            )}

                            {/* <li>
                                <Tooltip title="Filter" placement="top-start">
                                    <IconButton onClick={() => onMenuClick("filter", !showFilter)}>
                                        <FilterAltOutlinedIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                    </IconButton>
                                </Tooltip>
                            </li> */}
                        </Box>
                    </Box>
                </Box>
                <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                <Box 
                    sx={{ 
                        backgroundColor: '#FFFFFF', 
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden'
                    }}
                >
                    <DataGrid
                        sx={{
                            border: 'none',
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            
                            '& .MuiDataGrid-topContainer': {
                                backgroundColor: '#F8FAFC',
                                '&::after': { display: 'none' }
                            },
                            
                            // Customizing Enterprise Header Styling
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#F8FAFC',
                                borderBottom: '1px solid #E2E8F0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                color: '#475569',
                                fontWeight: 700,
                                fontSize: '13px',
                                textTransform: 'none',
                                letterSpacing: '0.1px',
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },
                            
                            // Customizing Rows, Cells and Interactive States Layout Bounds
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease-in-out',
                                borderBottom: '1px solid #F1F5F9',
                                alignItems: 'center',
                                '&:hover': {
                                    backgroundColor: '#F8FAFC'
                                },
                                '&.Mui-selected': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                    }
                                }
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '13.5px',
                                color: '#334155',
                                borderBottom: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                py: '12px', 
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },

                            // Global Selection Checkbox Interactivity Themes
                            '& .MuiCheckbox-root': {
                                color: '#CBD5E1',
                                '&.Mui-checked': {
                                    color: '#1976d2'
                                }
                            },

                            // Custom Linear Progress bar tracking layout styling overrides
                            '& .MuiLinearProgress-root': {
                                height: '3px',
                                backgroundColor: '#E2E8F0',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#1976d2'
                                }
                            }
                        }}
                        getRowId={(row) => row._id}
                        rows={manifest && manifest.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        slots={{
                            loadingOverlay: LinearProgress,
                            footer: CustomPagination,
                            toolbar: CustomToolbar,
                            NorowsData
                        }}
                        loading={
                            (manifest && manifest.loading)
                        }
                        checkboxSelection={!!profile?.enable_pickup_manifest}
                        isRowSelectable={(params) => 
                            params.row.status === 'CLOSED' && 
                            !params.row.pickup_enabled && 
                            !!profile?.enable_pickup_manifest
                        }
                        onRowSelectionModelChange={(newSelection) => {
                            const selectedManifestNumbers = (manifest?.data || [])
                                .filter(row => newSelection.includes(row._id) && !row.pickup_enabled)
                                .map(row => row.manifest_number);

                            setSelectedManifests(selectedManifestNumbers);
                        }}
                    />
                </Box>

            </div>
            {manifestId &&
                <ManifestDrawer
                    visible={manifestDrawerVisible} manifestId={manifestId} manifestOnClose={manifestOnClose} manifestUrl={manifestUrl}
                />
            }
            {manifestId && pendingShipmentsDrawerVisible && shipmentType!="" &&
                <PendingShipmentsDrawer
                    visible={pendingShipmentsDrawerVisible} manifestId={manifestId} pendingShipmentsOnClose={pendingShipmentsOnClose} shipmentType={shipmentType}
                />
            }
            {manifest && manifest.un_closed_shipments_count != 0 && unclosedShipmentsDrawerVisible &&
                <UnclosedShipmentDrawer
                    visible={unclosedShipmentsDrawerVisible} unclosedShipmentsOnClose={unclosedShipmentsOnClose}
                />
            }
            <PickupModal
                open={openPickupModal}
                onClose={handleClosePickupModal}
                addresses={addresssender.data || []}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                selectedDate={selectedDate}         // PASS VALUE
                setSelectedDate={setSelectedDate}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
                handlePickup={handlePickup} // Added this
                loading={isPickupLoading} // Pass the loading state here
            />


        </>
    );
}

export default ManifestsPage;
